import { type JsonObject, type JsonValue } from "@bufbuild/protobuf";

// alias for now
export const setStringValue = setValue;
export const setNumberValue = setValue;
export const setBooleanValue = setValue;
export const setStructValue = setValue;
export const setListValue = setValue;

export function setValue(struct: JsonObject | undefined, key: string, value: JsonValue) {
	if (!struct) {
		return;
	}
	struct[key] = value;
}

export function stringValue(struct: JsonObject | undefined, key: string): string | undefined {
	if (typeof struct?.[key] === "string") {
		return struct[key];
	}
	return undefined;
}

export function numberValue(struct: JsonObject | undefined, key: string): number | undefined {
	if (typeof struct?.[key] === "number") {
		return struct[key];
	}
	return undefined;
}

export function booleanValue(struct: JsonObject | undefined, key: string): boolean | undefined {
	if (typeof struct?.[key] === "boolean") {
		return struct[key];
	}
	return undefined;
}

export function unsetValue(struct: JsonObject | undefined, key: string) {
	if (!struct) {
		return;
	}
	delete struct[key];
}

export function structValue(struct: JsonObject | undefined, key: string): JsonObject | undefined {
	if (isObject(struct?.[key])) {
		return struct[key];
	}
	return undefined;
}

export function objectValue(struct: JsonObject | undefined, key: string): JsonObject | undefined {
	return structValue(struct, key);
}

export function listValue(struct: JsonObject | undefined, key: string): JsonValue[] | undefined {
	if (Array.isArray(struct?.[key])) {
		return struct[key];
	}
	return undefined;
}

export function cleanJson(json: JsonValue | undefined): JsonValue {
	if (json === undefined) return null; // coalesce undefined values to null

	if (Array.isArray(json)) {
		return json.map(m => cleanJson(m));
	} else if (typeof json === "object" && json !== null) {
		return Object.fromEntries(
			(Object.entries(json) as [string, JsonValue | undefined][])
				.filter(([, v]) => v !== undefined && v !== "") // omit undefined and empty values from objects
				.map(([k, v]) => [k, cleanJson(v)]),
		);
	}
	return json;
}

function isObject(j?: JsonValue): j is JsonObject {
	return typeof j === "object" && !Array.isArray(j) && j !== null;
}
